// import React, { useState } from 'react';
// import Sankey from './Sankey';
// import Areachart from './AreaChart';
// import MultipleSelectCheckmarks from './Dropdown';
// import { Box, Paper } from '@mui/material';
// // import Timeline from './TimelineChart';
// import FilterMenu from './FilterMenu';
// import LightScheduleChart from './lightScheduleChart';
// import StaffAvailabilityChart from './staffAvailabilityChart';
// import QueueChart from './QueueCount';
// import DualBarChart from './dualBarChart';
// import CustomerMetricsChart from './coustomerMetricChart';
// import CustomerEngagementChart from './customerEngagementChart';

// export default function TrendsChart() {
//   const [chartvalue, setChartValue] = useState('FootFall');
//   function graphToSelect(ChartData) {
//     setChartValue(ChartData);
//   }
//   return (
//     <Box
//     // sx={{width: "100vw", height:"100vh", display:"flex", justifyContent:"center", alignItems:"center"}}
//     >
//       <div className="flex w-full justify-between">
//         <MultipleSelectCheckmarks graphToSelect={graphToSelect} />
//         {chartvalue === 'FootFall' && <FilterMenu />}
//       </div>
//       <Paper elevation={0} sx={{ width: '100%', position: 'relative', height: '408px' }}>
//         {chartvalue == 'Light Timing' ? (
//           <LightScheduleChart />
//         ) : chartvalue == 'Staff Availability' ? (
//           <StaffAvailabilityChart />
//         ) : chartvalue == 'Queue Count' ? (
//           <QueueChart />
//         ) : chartvalue == 'Interaction' ? (
//           <DualBarChart />
//         ) : chartvalue == 'Departmental Conversion' ? (
//           <CustomerMetricsChart />
//         ) : chartvalue == 'Customer-Product Engagement' ? (
//           <CustomerEngagementChart />
//         ) : chartvalue == 'Journey' ? (
//           <Sankey />
//         ) : (
//           <Areachart />
//         )}
//         {/* chartvalue == 'Engagement' ? <Timeline /> */}
//       </Paper>
//     </Box>
//   );
// }



import React, { useState } from 'react';
import { Box, Paper } from '@mui/material';
import Chip from '@mui/material/Chip';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import AreaChart from './AreaChart';
import FilterMenu from './FilterMenu';

const FOOTFALL = 'FootFall';

function FootfallChip({ selected, onSelect }) {
  const isSelected = selected === FOOTFALL;

  return (
   <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
  <Chip
    key={FOOTFALL}
    label="Footfall"
    icon={<DirectionsWalkIcon />}
    onClick={() => onSelect?.(FOOTFALL)}
    clickable={Boolean(onSelect)}
    sx={{
      borderRadius: '20px',
      px: 1.5,
      mt: '2px',
      backgroundColor: isSelected ? '#44BE54' : '#f0f0f0',
      color: isSelected ? '#fff' : '#000',
      transition: 'background-color 0.2s ease-in-out',
      '& .MuiChip-icon': { color: isSelected ? '#fff' : '#000' },
      '&:hover': { backgroundColor: isSelected ? '#329242' : '#e0e0e0' }
    }}
  />
</Box>
  );
}

export default function TrendsChart() {
  const [chartValue, setChartValue] = useState(FOOTFALL);

  return (
    <Box>
      {/* Header: Footfall chip (left) + Filter menu (right) */}
      <div className="flex w-full items-center justify-between">
        <FootfallChip selected={chartValue} onSelect={setChartValue} />
        <FilterMenu />
      </div>

      {/* Only the Footfall chart */}
      <Paper elevation={0} sx={{ width: '100%', position: 'relative', height: '408px' }}>
        <AreaChart />
      </Paper>
    </Box>
  );
}
